import { createContext, useContext, type ReactNode } from 'react';

type AppShellContextValue = {
  clinicName: string;
  logoUrl?: string | null;
};

const AppShellContext = createContext<AppShellContextValue>({
  clinicName: 'Clinic workspace'
});

export function AppShellProvider({
  value,
  children
}: {
  value: AppShellContextValue;
  children: ReactNode;
}) {
  return <AppShellContext.Provider value={value}>{children}</AppShellContext.Provider>;
}

// eslint-disable-next-line react-refresh/only-export-components
export function useAppShellContext() {
  return useContext(AppShellContext);
}
